import { render, staticRenderFns } from "./InstanceTable.vue?vue&type=template&id=8b5067ee&scoped=true"
import script from "./InstanceTable.vue?vue&type=script&lang=js"
export * from "./InstanceTable.vue?vue&type=script&lang=js"
import style0 from "./InstanceTable.vue?vue&type=style&index=0&id=8b5067ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5067ee",
  null
  
)

export default component.exports